export enum WidgetPredefinedFilterEnum {
  branches = "branches",
  teams = "teams",
  branchesIntersectionTeams = "branchesIntersectionTeams",
  teamsExcludeBranches = "teamsExcludeBranches",
  branchesExcludeTeams = "branchesExcludeTeams",
  excludeTeams = 'excludeTeams'
}
